export default __webpack_public_path__ + "static/media/logo-icon.bbe54925.svg";